import { useEffect } from "react";
import { matchPath, Outlet, useLocation } from "react-router-dom";

export const LogisticsLayout = () => {
  const location = useLocation();

  const routes = [
    {
      id: 1,
      route: "/logistics",
      name: "Initiate",
    },
    {
      id: 2,
      route: "/logistics/cargo-details",
      name: "Cargo Details",
    },
    { id: 3, route: "/logistics/quotes", name: "Quotes" },
    // { id: 4, route: "/logistics/summary", name: "Summary" },
  ];

  const isActiveRoute = (route: string) => {
    return matchPath(location.pathname, route) !== null;
  };

  useEffect(() => {
    return () => {
      localStorage.removeItem("cargo-details");
    };
  }, []);

  return (
    <div>
      <div className="bg-white rounded-md p-8 border border-[#f3f3f5]">
        <div className=" flex">
          <nav className="p-1 flex flex-col gap-[1px] border-r border-[#EAECF0]">
            {routes.map((el) => (
              <div key={el.route}>
                <div
                  className={`w-[180px] py-2 transition-colors duration-700 ${
                    isActiveRoute(el.route)
                      ? "text-[#0348B7]"
                      : "text-[#475467]"
                  }`}
                >
                  <p className="flex items-center gap-1">
                    <span
                      className={`w-8 h-8 text-xs font-semibold rounded-full inline-flex items-center justify-center border-2 ${
                        isActiveRoute(el.route)
                          ? "text-[#0348B7] border-[#0348B7]"
                          : "border-[#D0D5DD]"
                      }`}
                    >
                      0{el.id}
                    </span>{" "}
                    {el.name}
                  </p>
                </div>
                {el.id !== routes.length && (
                  <div className="w-[1px] h-10 bg-[#D0D5DD] ml-4" />
                )}
              </div>
            ))}
          </nav>

          <div className="relative w-full">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
